<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="tabs-container">
        <ul class="nav nav-tabs" role="tablist">
          <li class="active"><a class="nav-link" data-toggle="tab"  href="#tags" @click="activeComponent = 'tagsTab'">Tags</a></li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane ibox-content active" role="tabpanel" id="feed">
            <div class="row">
              <component v-if="activeComponent" :is="activeComponent"></component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tags from './Tags/Tags'

export default {
  data () {
    return {
      name: 'Tags',
      activeComponent: 'tagsTab'
    }
  },
  components: {
    tagsTab: Tags
  },
  mounted () {
    document.title = 'Link Tags :: PBN360 by Aphex Media'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Tags.vue